import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { resetField, getRecipeNutritionFacts } from "../../../../store/actions";

class RecipeNutritionFacts extends Component {
	componentDidMount() {
		const { recipeId, getRecipeNutritionFacts } = this.props;
		if (recipeId) {
			getRecipeNutritionFacts(recipeId);
		}
	}

	componentDidUpdate(prevProps) {
		const { recipeId, getRecipeNutritionFacts, forceReload } = this.props;
		if ((recipeId && prevProps.recipeId !== recipeId) || prevProps.forceReload !== forceReload) {
			getRecipeNutritionFacts(recipeId);
		}
	}

	componentWillUnmount() {
		this.props.resetField("Recipes.recipeNutritionFacts", []);
	}

	renderItem = (list, showPercentage = true, isHeading = false) => {
		return (
			<React.Fragment>
				{list.map((item, index) => {
					const percentage = Math.round(item.dri_2000) + "%";
					return (
						<div
							className={`d-flex align-items-center pt-2 pb-2 ${isHeading ? "border-bottom-default" : ""}`}
							key={index}>
							<span className={`flex-fill mr-2 ${isHeading ? "bold" : ""}`}>
								{item.name} {item.val}
							</span>
							{showPercentage ? (
								<span className="bold text-primary-dark">{percentage}</span>
							) : (
								<span className="bold text-primary-dark text-right">{item.cal_fat}</span>
							)}
							{item.value && <div>{item.value}</div>}
						</div>
					);
				})}
			</React.Fragment>
		);
	};

	render() {
		const { recipeNutritionFacts } = this.props;
		return recipeNutritionFacts && recipeNutritionFacts.length
			? recipeNutritionFacts.map((item, index) => {
					let subCategoryList = [];
					if (item.sub_category) {
						subCategoryList = item.sub_category.map((item, index) => {
							return { ...item, id: index };
						});
					}
					if (item.name === "Serving size") {
						return (
							<React.Fragment key={index}>
								{this.renderItem([{ ...item, value: item.val, val: null, id: index }], false, true)}
							</React.Fragment>
						);
					} else if (item.name === "Calories") {
						return (
							<React.Fragment key={index}>
								{this.renderItem([{ ...item, id: index }], false, true)}
							</React.Fragment>
						);
					}
					return (
						<React.Fragment key={index}>
							{this.renderItem([{ ...item, id: index }], true, true)}
							<div className="pl-3">{item.sub_category && this.renderItem(subCategoryList, true, false)}</div>
						</React.Fragment>
					);
			  })
			: null;
	}
}

const mapStateToProps = (state) => {
	return {
		recipeNutritionFacts: get(state, "Recipes.recipeNutritionFacts", [])
	};
};

const mapDispatchToProps = { resetField, getRecipeNutritionFacts };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecipeNutritionFacts);
